import { jsNode } from '@shared/node-v1.0.0'

import v010 from '@nodes/format-date-v0.1.0'

export default jsNode(
	'formatDate',
	{
		'v0.1.0': v010,
	},
	{ docs: '', color: 'purple' }
)
